module.exports = __webpack_public_path__ + "static/media/scan-to-pay.7de419cc.svg";